import React, { useContext, useState } from "react";
import styles from "./Share.module.scss";
import { Context } from "../Store";
import FacebookButton from "./share/share-buttons/FaceBookButton";
import LinkButton from "./share/share-buttons/LinkButton";
import WhatsAppButton from "./share/share-buttons/WhatsAppButton";
import CopiedContext from "../CopiedContext";
import IsCopiedMessage from "./IsCopiedMessage";

const Share = () => {
  const [state] = useContext(Context);
  const [showCopied, setShowCopied] = useState(false); 
  const copied = { showCopied, setShowCopied };

  const getMediaShareURL = (country, guid) => {
    const domainMap = {
      us: "https://stories.us.flightclubdarts.com/",
      aus: "https://stories.flightclubdarts.com.au/",
      ie: "https://stories.flightclubdarts.ie/",
    };

    const baseURL = domainMap[country] || "https://stories.flightclubdarts.com/";
    return baseURL + guid;
  };

  const addUTMParams = (url, medium) => {
    const utmParams = new URLSearchParams({
      utm_source: "Stories",
      utm_medium: medium,
      utm_campaign: "share_with_friends",
    });

    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}${utmParams.toString()}`;
  };

  const mediaShareURL = getMediaShareURL(state.country, state.guid);
  const facebookShareURL = addUTMParams(mediaShareURL, "facebook_share");
  const whatsappShareURL = addUTMParams(mediaShareURL, "whatsapp_share");
  const linkShareURL = addUTMParams(mediaShareURL, "link_share");
  const shareText = "Check out the Story of my Flight Club visit: ";
  const sectionName = "Full Story";

  return (
    <CopiedContext.Provider value={copied}>
      <div className={`${styles.shareContainer} section section--padded`}>
        <h2>Share with friends</h2>
        <div className={styles.shareLinkWrapper}>
          <a className={styles.shareLink}>
            <FacebookButton mediaShareURL={facebookShareURL} shareText={shareText} mediaType={undefined} gameData={undefined} sectionName={sectionName} showLabel={true} />
          </a>
          <a className={styles.shareLink}>
            <LinkButton mediaShareURL={linkShareURL} shareText={shareText} mediaType={undefined} gameData={undefined} sectionName={sectionName} showLabel={true} />
          </a>
          <a className={styles.shareLink}>
            <WhatsAppButton mediaShareURL={whatsappShareURL} shareText={shareText} mediaType={undefined} gameData={undefined} sectionName={sectionName} showLabel={true} />
          </a>
        </div>
      <IsCopiedMessage />
      </div>
    </CopiedContext.Provider>
  );
};

export default Share;
